import request from '../utils/request';

/** 获取标签字典（供筛选器使用） */
export function fetchLabelDictionary() {
  return request.get('/labels/dictionary');
}

/** 查询标注分组列表（按 object_name 分组，不细化子 pb） */
export function fetchAnnotationGroups(params = {}) {
  return request.get('/annotation/groups', { params });
}

/** 查询场景标签任务列表（平铺） */
export function fetchTasks(params = {}) {
  return request.get('/tasks', { params });
}

export function fetchTaskDetail(id) {
  return request.get(`/tasks/${id}`);
}

export function fetchTaskSummary(id) {
  return request.get(`/tasks/${id}/summary`);
}

/** 获取某组的所有关键帧 ID（逐帧播放用）；camera 默认 front */
export function fetchAnnotationKeyframes(objectName, cameraPosition = 'front') {
  return request.get('/annotation/keyframes', {
    params: { object_name: objectName, camera_position: cameraPosition },
  });
}

/** 获取关键帧图片 URL（重定向到 MinIO 预签名） */
export function getKeyframeImageUrl(id) {
  return `/api/keyframes/${id}/image`;
}

/** 手动触发重新标注 */
export function triggerReannotate(objectName) {
  return request.post('/annotation/reannotate', { object_name: objectName });
}
